"use strict";
// Stremio Plus: what each kind of profile cannot reach.
// Kids content itself is filtered in plus/worker.js.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlockedPath = exports.blockedRoutesFor = exports.KIDS_AGE_OPTIONS = void 0;
// Only the account owner (main profile) manages addons.
var SECONDARY_BLOCKED_ROUTES = ['/addons'];
var KIDS_BLOCKED_ROUTES = ['/addons', '/settings'];
exports.KIDS_AGE_OPTIONS = [6, 10, 12, 16];
var blockedRoutesFor = function (profile) {
    if (profile === null || profile.isMain)
        return [];
    return profile.isKids ? KIDS_BLOCKED_ROUTES : SECONDARY_BLOCKED_ROUTES;
};
exports.blockedRoutesFor = blockedRoutesFor;
var isBlockedPath = function (profile, pathname) {
    return (0, exports.blockedRoutesFor)(profile).some(function (route) { return pathname === route || pathname.startsWith("".concat(route, "/")); });
};
exports.isBlockedPath = isBlockedPath;
